import en from './en.json';
import { useTranslation } from 'react-i18next';
const key = (value: string) => value.replace(/%(?:\d+\$)?(?:lld|ld|d|@)/g, part => part.endsWith('@') ? 'name' : 'count').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
const aliases = new Map<string, string>();
for (const [group, values] of Object.entries(en)) if (typeof values === 'object') for (const [name, text] of Object.entries(values)) if (typeof text === 'string') aliases.set(text, `${group}.${name}`);
export function useCopy() {
  const { t, i18n } = useTranslation('discover');
  return { t, locale: i18n.resolvedLanguage?.startsWith('zh') ? 'zh-Hans' as const : 'en' as const,
    c: (text: string, group = 'ui', args: Record<string, unknown> = {}) => t(i18n.exists(`discover:${group}.${key(text)}`) ? `${group}.${key(text)}` : aliases.get(text) ?? `${group}.${key(text)}`, { defaultValue: text, ...args }) };
}
